export const tr = {
    'minus-keywords-illegal-minus-keyword-chars':
        'Negatif anahtar sözcük gruplarında yalnızca Türkçe, İngilizce, Kazakça, Rusça, Ukraynaca veya Belarusça harfler, tırnak işaretleri, köşeli parantezler, "-", "+", "!" işaretleri ve boşluk kullanılabilir. Sözcük gruplarındaki hatalar: {minusWords}',
    'minus-keywords-imbalanced-square-brackets':
        'Negatif anahtar sözcük gruplarında "[" "]" hatalı köşeli parantez kullanımı: {minusWords}',
    'minus-keywords-invalid-dot':
        'Negatif anahtar sözcük grupları, noktadan sonra art arda iki basamaktan fazlasına izin vermez. Sözcük gruplarındaki hatalar: {minusWords}',
    'minus-keywords-invalid-exclamation-mark':
        'Negatif anahtar sözcük gruplarında hatalı "!" ünlem işareti kullanımı: {minusWords}\r',
    'minus-keywords-invalid-minus-mark':
        'Negatif anahtar sözcük gruplarında hatalı  "-" işareti kullanımı: {minusWords}. "-" işareti kelime başlarında ve sonlarında kullanılamaz',
    'minus-keywords-invalid-operators-inside-square-brackets':
        '[] köşeli parantezin içinde +-"" karakterleri kullanılamaz; negatif anahtar sözcük grupları: {minusWords}',
    'minus-keywords-invalid-plus-mark':
        'Negatif anahtar sözcük gruplarında "+" işaretinin hatalı kullanımı: {minusWords}\r',
    'minus-keywords-invalid-word-first-character':
        'Negatif anahtar sözcük gruplarında özel karakterlerin yanlış kombinasyonu: {minusWords}',
    'minus-keywords-max-count-words-in-keyword':
        'Negatif anahtar sözcük grubu en fazla {maxWords} sözcük olabilir: {minusWords}',
    'minus-keywords-max-length':
        'Negatif anahtar sözcük grubunda izin verilen kelime uzunluğu {maxLength} karakter aşıldı. Sözcük gruplarında hatalar: {minusWords}',
    'minus-keywords-max-length-minus-keywords':
        'Grup için negatif anahtar sözcük gruplarında {maxLength} karakter sınırı aşıldı',
    'minus-keywords-nested-or-empty-square-brackets':
        '"[" "]" köşeli parantez boş bırakılamaz ve ekli olamaz; negatif anahtar sözcük grupları: {minusWords}',
    'minus-keywords-null': 'Grup için negatif anahtar sözcük grupları boş değerler içeremez',
    'minus-keywords-separate-dot': 'Negatif anahtar sözcük grupları ayrı yazılan noktaları içeremez: {minusWords}',
    'minus-keywords-wrong-quote':
        'Negatif anahtar sözcük gruplarında tırnak işaretinin hatalı kullanımı: {minusWords}\r',
    'minus-phrase-binding-many-phrases-list-error': {
        one: 'Seçilen gruba diziler bağlanamadı',
        some: 'Seçilen gruplara diziler bağlanamadı',
        many: 'Seçilen gruplara diziler bağlanamadı',
        none: ''
    },
    'minus-phrase-binding-many-phrases-list-error-many': 'Seçilen gruplara diziler bağlanamadı',
    'minus-phrase-binding-many-phrases-list-error-one': 'Seçilen gruba diziler bağlanamadı',
    'minus-phrase-binding-many-phrases-list-success': {
        one: 'Diziler seçilen gruba bağlandı',
        some: 'Diziler seçilen gruplara bağlandı',
        many: 'Diziler seçilen gruplara bağlandı',
        none: ''
    },
    'minus-phrase-binding-many-phrases-list-success-many': 'Diziler seçilen gruplara bağlandı',
    'minus-phrase-binding-many-phrases-list-success-one': 'Diziler seçilen gruba bağlandı',
    'minus-phrase-binding-many-phrases-list-warning': {
        one: 'Diziler {count} / {total} gruba bağlandı. Diğerleri başarısız oldu ',
        some: 'Diziler {count} / {total} gruba bağlandı. Diğerleri başarısız oldu\r ',
        many: 'Diziler {count} / {total} gruba bağlandı. Diğerleri başarısız oldu\r ',
        none: ''
    },
    'minus-phrase-binding-one-phrases-list-error': {
        one: 'Dizi seçilen gruba bağlanamadı',
        some: 'Dizi seçilen gruplara bağlanamadı',
        many: 'Dizi seçilen gruplara bağlanamadı',
        none: ''
    },
    'minus-phrase-binding-one-phrases-list-error-many': 'Dizi seçilen gruplara bağlanamadı',
    'minus-phrase-binding-one-phrases-list-error-one': 'Dizi seçilen gruba bağlanamadı',
    'minus-phrase-binding-one-phrases-list-success': {
        one: 'Dizi seçilen gruba bağlı',
        some: 'Dizi seçilen gruplara bağlı',
        many: 'Dizi seçilen gruplara bağlı',
        none: ''
    },
    'minus-phrase-binding-one-phrases-list-success-many': 'Dizi seçilen gruplara bağlı',
    'minus-phrase-binding-one-phrases-list-success-one': 'Dizi seçilen gruba bağlı',
    'minus-phrase-binding-one-phrases-list-warning': {
        one: 'Dizi {count} / {total} gruba bağlandı. Diğerleri başarısız oldu',
        some: 'Dizi {count} / {total} gruba bağlandı. Diğerleri başarısız oldu',
        many: 'Dizi {count} / {total} gruba bağlandı. Diğerleri başarısız oldu',
        none: ''
    },
    'minus-phrase-unbinding-many-phrases-list-error': {
        one: 'Diziler seçilen gruptan ayrılamadı',
        some: 'Diziler seçilen gruplardan ayrılamadı',
        many: 'Diziler seçilen gruplardan ayrılamadı',
        none: ''
    },
    'minus-phrase-unbinding-many-phrases-list-error-many': 'Diziler seçilen gruplardan ayrılamadı',
    'minus-phrase-unbinding-many-phrases-list-error-one': 'Diziler seçilen gruptan ayrılamadı',
    'minus-phrase-unbinding-many-phrases-list-success': {
        one: 'Diziler seçilen gruptan ayrıldı',
        some: 'Diziler seçilen gruplardan ayrıldı',
        many: 'Diziler seçilen gruplardan ayrıldı',
        none: ''
    },
    'minus-phrase-unbinding-many-phrases-list-success-many': 'Diziler seçilen gruplardan ayrıldı',
    'minus-phrase-unbinding-many-phrases-list-success-one': 'Diziler seçilen gruptan ayrıldı',
    'minus-phrase-unbinding-many-phrases-list-warning': {
        one: 'Diziler {count} / {total} gruptan ayrıldı. Diğerleri başarısız oldu\r ',
        some: 'Diziler {count} / {total} gruptan ayrıldı. Diğerleri başarısız oldu ',
        many: 'Diziler {count} / {total} gruptan ayrıldı. Diğerleri başarısız oldu ',
        none: ''
    },
    'minus-phrase-unbinding-one-phrases-list-error': {
        one: 'Dizi seçilen gruptan ayrılamadı',
        some: 'Dizi seçilen gruplardan ayrılamadı',
        many: 'Dizi seçilen gruplardan ayrılamadı',
        none: ''
    },
    'minus-phrase-unbinding-one-phrases-list-error-many': 'Dizi seçilen gruplardan ayrılamadı',
    'minus-phrase-unbinding-one-phrases-list-error-one': 'Dizi seçilen gruptan ayrılamadı',
    'minus-phrase-unbinding-one-phrases-list-success': {
        one: 'Dizi seçilen gruptan ayrıldı',
        some: 'Dizi seçilen gruplardan ayrıldı',
        many: 'Dizi seçilen gruplardan ayrıldı',
        none: ''
    },
    'minus-phrase-unbinding-one-phrases-list-success-many': 'Dizi seçilen gruplardan ayrıldı',
    'minus-phrase-unbinding-one-phrases-list-success-one': 'Dizi seçilen gruptan ayrıldı',
    'minus-phrase-unbinding-one-phrases-list-warning': {
        one: 'Dizi {count} / {total} gruptan ayrıldı. Diğerleri başarısız oldu',
        some: 'Dizi {count} / {total} gruptan ayrıldı. Diğerleri başarısız oldu',
        many: 'Dizi {count} / {total} gruptan ayrıldı. Diğerleri başarısız oldu',
        none: 'Dizi {count} / {total} gruptan ayrıldı. Diğerleri başarısız oldu'
    }
};
